import tokens from 'scripts/presentation/themes/tokens';

// Resolve a stored color token name to a CSS custom-property reference.
// Returns undefined for unknown names, which callers can use as a validity check.
export function cssVarForChannelColor(colorName) {
  return tokens.colors[colorName];
}
